/**
 * 优惠券中心
 */

import { Message } from "pp-ui";
import interceptor from "@block/config/interceptor";
import vatTaxFiling from "./vatTaxFiling";

const config: any = {
  baseURL: process.env.VUE_APP_BASEURL,
  withCredentials: true
};
console.log(process.env, process.env.VUE_APP_BASEURL);
const generateConfig: any = {
  request: interceptor.request,
  response: interceptor.response,
  config
};
const vatApi: any = {
  api: vatTaxFiling,
  ...generateConfig
};
export default vatApi;
